import { createAction } from '@reduxjs/toolkit';
import { type BoundaryGroupCodenames } from '~/boundary/boundary.types';
import { type CreateCustomBoundaryMode } from '~/sidebar/sidebarApps/mapTools/boundary/loadBoundaryPane/createCustomBoundaryPane/createCustomBoundaryGroupPane.component';
import { type BoundaryActionType } from '~/sidebar/sidebarApps/mapTools/boundary/loadBoundaryPane/loadBoundaryPane.component';
import { type BoundaryTerritoryType } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroup.type';
import {
  BOUNDARY_FORM_RESET, BOUNDARY_FORM_SET_TYPE_AND_MODE,
} from './boundaryForm.actionTypes';

export const boundaryFormReset = () => ({
  type: BOUNDARY_FORM_RESET,
}) as const;

export const boundaryFormSetType = (type: BoundaryActionType | null) => ({
  type: BOUNDARY_FORM_SET_TYPE_AND_MODE,
  payload: {
    type,
    mode: null,
  },
}) as const;

export const boundaryFormSetTypeAndMode = (type: BoundaryActionType | null, mode: CreateCustomBoundaryMode | null) => ({
  type: BOUNDARY_FORM_SET_TYPE_AND_MODE,
  payload: {
    type,
    mode,
  },
}) as const;

export const boundaryFormSetPreselected = createAction('BOUNDARY_FORM_SET_PRESELECTED',
  (payload: {
    boundaryGroupCodename: BoundaryGroupCodenames | null;
    boundaryTerritoryType: BoundaryTerritoryType | null;
    demographicName: string | null;
  }) => ({ payload }));
